<template>
    <div>
        <div class="banner location-bn">
            <img src="@/assets/images/banner9.png" alt="">
            <h2 class="title">Location｜好喝好玩的在這裡</h2>
        </div>
        <div class="wrap">
            <section id="tabs-block" class="section">
                <ul class="text-center">
                    <li>
                        <a href="javascript:void(0);" class="tabs-item tabsFilter" @click="select_type('landmark')">
                            <div class="name">地標<br>介紹</div>
                            <p>Landmark</p>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);" class="tabs-item tabsFilter" @click="select_type('merchant')">
                            <div class="name">商家<br>介紹</div>
                            <p>Store</p>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);" class="tabs-item tabsFilter" @click="select_type('all')">
                            <div class="name">所有<br>地點</div>
                            <p>All Location</p>
                        </a>
                    </li>
                </ul>
            </section>
            <section class="section filter-block">
                <div class="row">
                    <div v-for="location in location_lists" :key="location.id" class="col col2" data-category="Landmark">
                        <div class="card">
                            <div class="left">
                                <div class="img">
                                    <img :src="JSON.parse(location.images_url)[0]" :alt="location.title">
                                </div>
                                <p>{{ location.title }}</p>
                            </div>
                            <div class="right">
                                <div class="name">
                                    {{the_type[location.environment_type]}}
                                    <span>
                                        {{the_type_en[location.environment_type]}}
                                    </span>
                                </div>
                                <ul>
                                    <li>
                                        <div style="white-space: pre-line;">
                                            {{ location.content }}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <router-link :to="{name: 'locationPage', params: {id: location.id} }" class="link">
                                深入了解
                            </router-link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'location',
    data () {
        return {
            location_lists: [],
            the_type: {
                landmark: '地標介紹',
                merchant: '商家介紹'
            },
            the_type_en: {
                landmark: 'Landmark',
                merchant: 'Store'
            }
        }
    },
    beforeMount: function () {
        const formData = new FormData();
        formData.append('CMD', 'LocationList');
        formData.append('get_type', 'all');
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
        .then(response => {
            // console.log(response);
            if (response.data.result == false) {
                console.log('LocationList: Server Error');
            } else {
                const get_lists = response.data.location_lists;
                this.location_lists = get_lists;
            }
        })
        .catch(error => {
            console.log(error);
        })
    },
    methods: {
        get_list (type) {
            const getData = new FormData();
            getData.append('CMD', 'LocationList');
            getData.append('get_type', type);
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, getData)
            .then(response => {
                // console.log(response);
                if (response.data.result == false) {
                    console.log('LocationList: Server Error');
                } else {
                    const get_lists = response.data.location_lists;
                    this.location_lists = get_lists;
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        select_type(type) {
            this.get_list (type);
        }
    }
};
</script>

<style>

</style>
